<script>
const textStyle = {
	color: 'var(--neutral-40040)',
	fontSize: '12px',
	fontFamily: 'Avenir-Book',
}
const lineStyle = {
	borderTop: '1px solid var(--neutral-200)',
}

const originalFormatter = moment.calendarFormat
moment.calendarFormat = function calendarFormat(date, now) {
	// https://momentjs.com/docs/#/customization/calendar-format/
	// add some new options for our specific use cases
	const diff = date.diff(now, 'days')
	if (date.isBefore(now, 'year')) return 'pastYear'
	if (date.isSame(now, 'year') && diff < -7) return 'pastMonth'
	if (date.isSame(now, 'year') && diff < -1 && diff > -7) return 'lastWeek'

	// replicate original moment calendar behavior
	return originalFormatter(date, now)
}

export default { name: 'DateDivider' }
</script>

<script setup>
import moment from 'moment'
import { TextDivider } from '@/components/common'
import ThreadLine from './ThreadLine'
import { computed, getCurrentInstance } from 'vue'
import { getLocalDate } from '@/helpers/utils'
const { proxy } = getCurrentInstance()
const props = defineProps({
	date: [Date, String],
	needsThreadLine: { type: Boolean, default: null },
})

const formattedDate = computed(() => {
	if (!props.date) return ''
	const date = getLocalDate(props.date)
	return moment(date).calendar(null, {
		sameDay: `[${proxy.$t('common_today')}]`,
		lastDay: `[${proxy.$t('common_yesterday')}]`,
		lastWeek: 'dddd',
		pastMonth: 'MMMM Do',
		pastYear: 'll',
		sameElse: 'll',
	})
})
</script>

<template>
	<div class="date-divider-container">
		<TextDivider
			class="date-divider"
			:text="formattedDate"
			:textStyle="textStyle"
			:lineStyle="lineStyle"
		/>
		<ThreadLine v-if="needsThreadLine" class="thread" />
	</div>
</template>

<style lang="scss" scoped>
.date-divider-container {
	position: relative;
	padding: 8px 0;
	.date-divider {
		position: relative;
		z-index: 0;
		height: 16px;
		text-transform: capitalize;
	}
	.thread {
		position: relative;
		z-index: 1;
		:deep(.thread-line) {
			top: -24px;
			bottom: -8px;
		}
	}
}
</style>
